module.exports = __webpack_public_path__ + "img/d10edc9.png";